var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWhoMore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "8px",
    viewBox: "0 0 40 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icWhoMore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Looking-for---stage-1",
    transform: "translate(-278.000000, -397.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icWhoMore",
    transform: "translate(278.000000, 397.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 C6.2092,0 8,1.7908 8,4 C8,6.2084 6.2092,8 4,8 C1.7908,8 0,6.2084 0,4 C0,1.7908 1.7908,0 4,0",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C22.2092,0 24,1.7908 24,4 C24,6.2084 22.2092,8 20,8 C17.7912,8 16,6.2084 16,4 C16,1.7908 17.7912,0 20,0",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,0 C38.2092,0 40,1.7908 40,4 C40,6.2084 38.2092,8 36,8 C33.7912,8 32,6.2084 32,4 C32,1.7908 33.7912,0 36,0",
    id: "Fill-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhoMore);
export default __webpack_public_path__ + "static/media/icWhoMore.89577351ad67910098a119ddb472e6be.svg";
export { ForwardRef as ReactComponent };